import React from 'react';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import CommonButton from '@src/new-components/Button';
import { COLOR } from '@src/styles/color';
import { useTranslation } from 'react-i18next';
import Typography from '@src/new-components/Typography';
import routes from '@src/constants/route';
import { StyledTransactionHistoryHeader } from './index.style';

const TransactionHistoryHeader = () => {
  const { t } = useTranslation();
  return (
    <StyledTransactionHistoryHeader>
      <CommonButton
        aria-label="close"
        variant="outlineSmall"
        customStyle={{
          width: '40px',
          height: '40px',
          minWidth: '40px',
        }}
        onClick={() => {
          if (window.history.length > 1 && document.referrer) {
            window.history.back();
          } else {
            window.location.replace(routes.EARNINGS_MANAGEMENT);
          }
        }}
      >
        <ArrowBackRoundedIcon
          sx={{ fontSize: '24px', color: COLOR.navyBlue }}
        />
      </CommonButton>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
        <Typography variant="body-24-bold" color={COLOR.darkGray}>
          {t('transactionHistory')}
        </Typography>
        <Typography variant="body-16-regular" color={COLOR.descriptionUpload}>
          {t('checkWithdrawalRequestsAndRewards')}
        </Typography>
      </div>
    </StyledTransactionHistoryHeader>
  );
};

export default TransactionHistoryHeader;
